import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordResetService } from '../service/password-reset.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { PasswordValidator } from '../../utility/custom-validator/passwordValidator';

@Component({
	selector: 'app-password-reset-core',
	template: ''
})
export class PasswordResetComponent implements OnInit {
	public passkey: string;
	public userid: string;
	public password = '';
	public confirmPassword = '';
	public errorMessage: string;
	public passwordLength = 6;
	public invalidPassword = false;
	public invalidInput = false;
	public showForm = true;
	resetPwdgrp: UntypedFormGroup;

	errorMessages: string[];

	constructor(
		private route: ActivatedRoute,
		private passwordResetService: PasswordResetService,
		private router: Router
	) {
		this.errorMessages = [
			'Please fill all the details.',
			'Password must have ' + this.passwordLength + ' characters.',
			'New password and Confirm new password are not same.',
			'Something went wrong. Please try after some time.'
		];
	}

	ngOnInit() {
		this.route.params.subscribe((params: any) => {
			this.passkey = params['passkey'];
			this.userid = params['userid'];
		});
		this.resetPwdgrp = new UntypedFormGroup({
			password: new UntypedFormControl('', Validators.compose([])),
			signUpConfirmPwd: new UntypedFormControl('', Validators.compose([]))
		});
	}

	validateUser() {
		if (!this.resetPwdgrp.invalid) {
			const details = {
				passkey: this.passkey,
				userid: this.userid,
				password: this.password
			};
			this.passwordResetService.changePassword(details).subscribe(
				(res: any) => {
					if (res.success) {
						this.showForm = false;
					} else {
						this.errorMessage = res.message;
						this.showForm = true;
					}
				},
				function (error) {
					this.errorMessage = this.errorMessages[3];
				}
			);
		}
	}

	validateUserAll() {
		this.validateUser();
	}

	redirectToLogin() {
		this.router.navigate(['login']);
	}
}
